<template>
  <div>
    <div v-if="appleError" class="text-white text-red bg-red-1 q-pa-xs q-mb-md text-center">
      {{ appleError }}
    </div>
    <q-btn
      @click="signInWithApple()"
      :loading="checkInProgress"
      class="full-width bg-white"
      padding="6px"
      no-caps
      unelevated
      style="border: 1px solid #ddd">
      <div class="row items-center full-width q-pl-xs text-grey-9">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 384 512">
          <path
            fill="#555555"
            d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
        </svg>
        <div class="col q-pr-sm">{{ t`Вхід через Apple` }}</div>
      </div>
    </q-btn>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { checkToken } from '@nitra/components/njs/token.js'
import tf from '@nitra/tf/webpack'

// Завантажуємо скрипт Apple асинхронно
const scriptTag = document.createElement('script')
scriptTag.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
scriptTag.async = true
scriptTag.defer = true
document.head.append(scriptTag)

const props = defineProps({
  // apple signin options
  id: { type: String, default: null, required: true }
})

// событие когда пользователь авторизован
const emit = defineEmits(['input'])

const tr = {
  'Вхід через Apple': 'Вход через аккаунт Apple',
  'Помилка Apple авторизації': 'Ошибка авторизации Apple',
  'Користувачу ': 'Пользователю ',
  ' не дозволено входити': ' не разрешен вход'
}
const t = tf.bind({ tr })

// console.log('props.id', props.id)
const appleSignInOptions = {
  clientId: props.id,
  redirectURI: `https://${window.location.host}/not-used-with-popup`, // Не використовується з popup, але потрібно щоб було задано
  // та й ще це повинен бути той самий домен, який вказаний в apple developer
  // та й поточного домену де кнопка
  scopes: '', // в якості id будемо брати sub
  state: 'origin:web', // Any string of your choice that you may use for some logic. It's optional and you may omit it.
  usePopup: true // Important if we want to capture the data apple sends on the client side.
}

// лоадер
const checkInProgress = ref(false)

// APPLE
const appleError = ref('')

const signInWithApple = async () => {
  checkInProgress.value = true
  appleError.value = ''

  try {
    window.AppleID.auth.init(appleSignInOptions)

    const { authorization } = await window.AppleID.auth.signIn()

    if (!authorization.id_token) {
      checkInProgress.value = false
      return
    }

    const headers = {
      'Content-Type': 'application/json'
    }
    if (process.env.APP) {
      headers['app'] = process.env.APP
    }

    // пользователь авторизован
    try {
      const respFromRun = await fetch('/auth/apple', {
        method: 'POST',
        headers,
        body: JSON.stringify({
          idToken: authorization.id_token
        })
      })

      const res = await respFromRun.json()

      if (res?.token) {
        // Перенаправляємо користувача на home, якщо йому дозволено тільки home
        if (checkToken(res.token)) {
          emit('input', true)
        } else {
          appleError.value = t`Користувачу не дозволено входити`
        }
      } else {
        appleError.value = t`Помилка Apple авторизації`
      }
    } catch (error) {
      appleError.value = error
    }
  } catch (error) {
    console.log(error)
  }

  checkInProgress.value = false
}
</script>
